import React from 'react'
import { ChromePicker } from 'react-color'

class ColorPicker extends React.Component {
    static getDerivedStateFromProps(props, state) {
        if (state.prevPropValue !== props.value) {
            return {
                prevPropValue: props.value,
                value: props.value,
            }
        }
        return {}
    }

    constructor(props) {
        super(props)
        this.state = {
            value: this.props.value,
            prevPropValue: null,
            show: false,
        }
        this.handleChangeComplete = this.handleChangeComplete.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.onColorClick = this.onColorClick.bind(this)
        this.onPickerClick = this.onPickerClick.bind(this)
        this.onDocClick = this.onDocClick.bind(this)
    }

    handleChangeComplete(color) {
        this.setState({ value: color.hex })
        this.props.onUpdate(this.props.id, { [this.props.name]: color.hex })
    }

    handleChange() {}

    onColorClick(e) {
        this.setState({ show: true })
        setTimeout(() => {
            document.addEventListener('click', this.onDocClick)
        }, 1)
    }

    onPickerClick(e) {
        e.nativeEvent.stopImmediatePropagation()
    }

    onDocClick() {
        document.removeEventListener('click', this.onDocClick)
        this.setState({ show: false })
    }

    componentDidMount() {}

    componentWillUnmount() {
        document.removeEventListener('click', this.onDocClick)
    }

    render() {
        const { show, value } = this.state
        const stc = {
            backgroundColor: value,
        }
        const stp = {
            display: show ? 'block' : 'none',
        }
        return (
            <div className="color-picker-wr">
                <div className="color-picker-c" style={stc} onClick={this.onColorClick}></div>
                <div className="color-picker-s" style={stp} onClick={this.onPickerClick}>
                    <ChromePicker
                        width="auto"
                        color={value}
                        onChange={this.handleChange}
                        onChangeComplete={this.handleChangeComplete}
                    />
                </div>
            </div>
        )
    }
}

export default ColorPicker
